// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__j-y1h","link":"LoginForm_link__pEuZy","btn":"LoginForm_btn__ORFTM","info":"LoginForm_info__a9-58"};